import GraphData from '@/generated/classes/GraphData';
import { GraphAnswer as GraphAnswerBase } from '@/generated/classes/GraphData';
import { GraphMinimum as GraphMinimumBase } from '@/generated/classes/GraphData';
export default class GraphDataExtend extends GraphData {
  constructor() {
    super();
  }
}
export class GraphAnswer extends GraphAnswerBase {
  constructor() {
    super();
  }
}
export class GraphMinimum extends GraphMinimumBase {
  constructor() {
    super();
  }
}
